// areascontrolcambiosSchema.tsx

import * as yup from 'yup';

export const areascontrolcambiosSchema = yup.object({
    areaId: yup.string().optional(),
    nombre: yup
        .string()
        .required("El nombre es obligatorio")
        .matches(
        /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/,
        "Solo se permiten letras y espacios"
    ),

    descripcion: yup
    .string()
    .required('La descripción es obligatoria')
    .matches(
        /^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9.,\s]+$/,
        'Solo se permiten letras, números, espacios, puntos, comas y caracteres con tilde'
    ),
    activo: yup.boolean().required(),
});
